import React, { useState } from "react";
import "./PayrollAdminCreation.scss";
import {
  NewPortaluser,
  PictureNew,
  MerchantPiAdd,
} from "../../util/API/customers";
import CustomForm from "../UI/CustomForm/CustomForm";
import { formatDate } from "../../util/utilfunctions/utilFunctions";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { Box, TextField, Typography } from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import PayrollCredentialsModal from "./PayrollCredentialsModal";
function PayrollAdminCreation({
  open,
  handleClose,
  roles,
  updateUser,
  setUpdateUser,
  payrollUsers,
}) {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthDate: "",
    role: "",
    areaCode: "",
    city: "",
    country: "",
    zip: "",
    address: "",
    areaCodeCountry: "",
  });
  const [credentialsModal, setCredentialsModal] = useState({
    open: false,
    username: "",
    password: "",
    pin: "",
  });
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");

  const [phoneError, setPhoneError] = useState("");
  const [zipError, setZipError] = useState("");

  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
  });

  const [userImage, setUserImage] = useState("");
  const [userBase64, setUserBase64] = useState("");
  const [errors, setError] = useState("");
  const [newUser, setNewUser] = useState("");

  const handleCloseModal = () => {
    handleClose();
    setNewUser("");
    setError("");
    setCompanyName("");
    setCompanyNameError("");
    setPhoneError("");
    setZipError("");
    //setAlert({ showAlert: false, message: "", severity: "", header: "" });
  };

  const encodedLength = (str) => {
    if (!str) return 0;
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;").length;
  };
  // Phone validation on submit: must be ONLY digits + length check
  const validatePhone = (areaCode, phone) => {
    if (!areaCode?.value || !phone?.trim()) {
      return "Phone number is required";
    }

    // Step 1: Combine area code + phone exactly as user typed
    const fullInput = String(areaCode.value) + String(phone.trim());

    // Step 2: Remove ALL whitespace first (spaces, tabs, etc.)
    const noSpaces = fullInput.replace(/\s+/g, "");

    // Step 3: Check if it starts with optional single '+' followed by digits only
    const phoneRegex = /^\+?\d+$/; // + optional, then only digits till end

    if (!phoneRegex.test(noSpaces)) {
      return "Phone number must contain only digits";
    }

    // Step 4: Count actual digits (exclude the + if present)
    const digitsOnly = noSpaces.replace(/\D/g, "");
    const digitCount = digitsOnly.length;

    if (digitCount < 7) {
      return "Phone number must have at least 7 digits";
    }

    if (digitCount > 15) {
      return "Phone number cannot exceed 15 digits";
    }

    return "";
  };

  const validateZip = (zip) => {
    if (!zip?.trim()) return "ZIP / Postal Code is required";

    const cleaned = zip.trim();

    if (cleaned.length < 3 || cleaned.length > 10) {
      return "ZIP / Postal Code must be 3–10 characters";
    }

    return "";
  };

  const handleSubmit = async (data, formData) => {
    setNewUser("");
    setError("");
    setCompanyNameError("");
    setPhoneError("");
    setZipError("");

    // Company name check
    if (!companyName.trim()) {
      setCompanyNameError("Company Name is required");
      setAlert({
        showAlert: true,
        message: "Company Name is required",
        severity: "error",
        header: "Validation Error",
      });
      return;
    }

    if (encodedLength(companyName) > 60) {
      setCompanyNameError("Company name is too long ");
      setAlert({
        showAlert: true,
        message:
          "Company name cannot exceed 60 characters after accounting for special characters.",
        severity: "error",
        header: "Validation Error",
      });
      return;
    }

    // Phone validation (this is where we enforce digits only)
    const phoneErr = validatePhone(data.areaCode, data.phoneno);
    setPhoneError(phoneErr);

    // ZIP validation
    const zipErr = validateZip(data.zip);
    setZipError(zipErr);

    // If ANY error → show alert + stop
    if (phoneErr || zipErr) {
      let errorMsg = "Please fix the following issues:";
      if (phoneErr) errorMsg += `\n- ${phoneErr}`;
      if (zipErr) errorMsg += `\n- ${zipErr}`;

      setAlert({
        showAlert: true,
        message: errorMsg,
        severity: "error",
        header: "Invalid Input",
      });
      return;
    }

    // Rest of your required fields check...
    const requiredFields = formData
      .filter((field) => field.validation?.required)
      .map((field) => field.name);

    const missingFields = requiredFields.filter(
      (fieldName) =>
        !data[fieldName] || data[fieldName].toString().trim() === "",
    );

    if (missingFields.length > 0) {
      setAlert({
        showAlert: true,
        message: "Please fill all required fields",
        severity: "error",
        header: "Missing Fields",
      });
      return;
    }

    // Your existing logic...
    let phoneNo = data.areaCode.value + data.phoneno;

    let requestData = { ...data };

    if (requestData?.dob) {
      requestData.dob = formatDate(requestData.dob);
    }

    if (requestData?.phoneno) {
      requestData.phoneno = phoneNo;
    }

    let extendedFields = {};
    formData.forEach((item) => {
      if (item.core === 0 && requestData.hasOwnProperty(item.name)) {
        extendedFields[item.name] = requestData[item.name];
        delete requestData[item.name];
      }
    });

    requestData.otherNames = companyName.trim();
    requestData.extendedFields = JSON.stringify(extendedFields);

    try {
      const response = await NewPortaluser(requestData);
      console.log("Payroll Admin Creation Response:", response);

      let callStatus = response.data.Status;

      if (callStatus === "3") {
        let userId = response?.data?.payload?.userid;

        await MerchantPiAdd(userId, 229, 2);
        await MerchantPiAdd(userId, 230, 2);
        await MerchantPiAdd(userId, 313, 42);
         // Credentials are now emailed directly to the user's primary email
  // (see registerPortalUser backend) — no need to surface them in a popup.
  setAlert({
    showAlert: true,
    message: "Thank You! Payroll Admin has been created successfully! Login credentials have been sent to your email.",
    severity: "success",
    header: "Success",
  });

        setCompanyName("");

        setUserData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          birthDate: "",
          areaCode: "",
          city: "",
          country: "",
          zip: "",
          address: "",
          role: "",
        });

        if (userBase64) {
          await PictureNew(userId, userBase64);
        }


        //handleCloseModal();
      } else {
        // Get the backend's error message (try multiple possible paths)
        let backendMsg =
          response?.data?.msg ||
          response?.data?.payload?.msg ||
          response?.data?.payload?.errorMsg ||
          "";

        // If backendMsg is empty or falsy, use fallback
        if (!backendMsg) {
          backendMsg = "Failed to create Payroll Admin";
        }

        // Lowercase for case-insensitive checks
        const lowerMsg = backendMsg.toLowerCase();

        // Detect duplicate email using common phrases
        if (
          lowerMsg.includes("email") &&
          (lowerMsg.includes("already") ||
            lowerMsg.includes("exists") ||
            lowerMsg.includes("registered") ||
            lowerMsg.includes("duplicate") ||
            lowerMsg.includes("can not be registered"))
        ) {
          backendMsg = "Payroll Admin already exists with this email";
        } else if (
          lowerMsg.includes("invalid email") ||
          lowerMsg.includes("invalid email set for") // Matches the example you provided
        ) {
          backendMsg =
            "Please enter a valid email address (e.g., name@example.com)";
        }

        setError(backendMsg);
        setAlert({
          showAlert: true,
          message: backendMsg,
          severity: "error",
          header: "Creation Failed",
        });
      }
    } catch (error) {
      console.error("Error creating payroll admin:", error);
      setError("An error occurred while creating the user.");
      setAlert({
        showAlert: true,
        message: "An unexpected error occurred. Please try again.",
        severity: "error",
        header: "Error",
      });
    }
  };

  return (
    <BaseDrawer
      open={open}
      handleClose={handleCloseModal}
      height="90vh"
      title="New Payroll Admin"
    >
      <Box className="portal-creation-container">
        {/* Company Information */}
        <Box
          sx={{
            p: 3,
            backgroundColor: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            mb: 3,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, mb: 1, color: "#1e293b" }}
          >
            Company Information
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Please provide the company name for this Payroll Admin. This will be
            stored securely and associated with the account.
          </Typography>

          <Box sx={{ maxWidth: 600, mx: "auto" }}>
            <TextField
              fullWidth
              label="Company Name"
              placeholder="e.g., Acme Corporation Inc."
              value={companyName}
              onChange={(e) => {
                const newValue = e.target.value;
                setCompanyName(newValue); // Always update — never block input
                if (encodedLength(newValue) > 60) {
                  setCompanyNameError(
                    "Company name is too long (max 60 characters)",
                  );
                } else {
                  setCompanyNameError("");
                }
              }}
              error={!!companyNameError}
              helperText={
                companyNameError || "This field is required (max 60 characters)"
              }
              required
              //inputProps={{ maxLength: 60 }} // ← Browser-level hard limit
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#ffffff",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#3bc97b",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#3bc97b",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": { color: "#3bc97b" },
              }}
            />
          </Box>
        </Box>

        <Box className="newrole-container">
          <Box className="customer-photos">{/* Image upload preserved */}</Box>

          <Box className="admin-details">
            <CustomForm
              formName="newagent"
              fieldRendererType="registration"
              onSubmit={handleSubmit}
              buttonText="Add Payroll Admin"
              loadingButtonText="Adding Payroll Admin..."
              twoColumns={true}
              buttonInPanel={true}
              roles={roles}
              isRegistration={true}
            />
          </Box>
        </Box>
      </Box>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={() => {
          setAlert({ ...alert, showAlert: false });
          if (alert.severity === "success") {
            setUpdateUser(!updateUser);
            handleCloseModal();
          }
        }}
        autoclose={false}
      />

      <PayrollCredentialsModal
        open={credentialsModal.open}
        username={credentialsModal.username}
        password={credentialsModal.password}
        pin={credentialsModal.pin}
        modalText="Payroll Admin Created Successfully"
        onClose={() => {
          setCredentialsModal({ open: false, username: "", password: "", pin: "" });
          setUpdateUser(!updateUser);
          handleCloseModal();
        }}
      />
    </BaseDrawer>
  );
}

export default PayrollAdminCreation;
